export const TEXTS = {
  errors: {
    network: "Network error or incorrect data from server",
  },
  buttons: {
    continue: "Continue",
    close: "Close",
    again: "Again?",
    detail: "Detail",
  },
};
